// Utility for announcing dynamic content to screen readers
export class Announcer {
  static #element = null

  static getElement() {
    if (!this.#element) {
      this.#element = document.createElement('div')
      this.#element.id = 'sr-announcer'
      this.#element.setAttribute('aria-live', 'polite')
      this.#element.setAttribute('aria-atomic', 'true')
      this.#element.className = 'sr-only'
      document.body.appendChild(this.#element)
    }
    return this.#element
  }

  static announce(message, priority = 'polite') {
    const el = this.getElement()
    el.setAttribute('aria-live', priority)
    // Clear and re-set to trigger announcement
    el.textContent = ''
    setTimeout(() => {
      el.textContent = message
    }, 100)
  }

  static announceAssertive(message) {
    this.announce(message, 'assertive')
  }
}

// Auto-initialize announcer on page load
document.addEventListener('DOMContentLoaded', () => {
  Announcer.getElement()
})

// Also initialize on turbo:load for Turbo Drive navigation
document.addEventListener('turbo:load', () => {
  Announcer.getElement()
})
